import { render, staticRenderFns } from "./upload-button.vue?vue&type=template&id=06e5cc94&scoped=true"
var script = {}
import style0 from "./upload-button.vue?vue&type=style&index=0&id=06e5cc94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e5cc94",
  null
  
)

export default component.exports